import { useState } from 'react';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core';

import Button from '~/ui/components/common/Button';
import NoDataFound from '~/ui/components/reusable/NoDataFound';
import Icd10CodeModal from '../popups/Icd10CodeModal';
import Item from './Item';

import { ICarePlanIcd10Code } from '~/services/api/carePlanIcd10Codes/types';
import { IPagePermissions } from '../../types';
import styles from './Icd10Codes.module.scss';
import getInitialValues from './form/getInitialValues';

interface IProps {
  patientId: number;
  items: ICarePlanIcd10Code[];
  permissions: IPagePermissions;
  onCarePlanChange: () => void;
}

const Icd10Codes = ({ patientId, items, permissions, onCarePlanChange }: IProps) => {
  const [showCreate, setShowCreate] = useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.headerWrapper}>
        <div className={styles.title}>Diagnoses (ICD-10)</div>
        {permissions.canManage && (
          <Button variant="contained" color="primary" onClick={() => setShowCreate(true)}>
            + Add New
          </Button>
        )}
      </div>
      <div className={styles.tableContainer}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell width="20%">Type</TableCell>
                <TableCell width="10%">Code</TableCell>
                <TableCell>Description</TableCell>
                {permissions.canManage && <TableCell width={120} />}
              </TableRow>
            </TableHead>
            <TableBody>
              {items.length ? (
                items.map(item => (
                  <Item
                    key={item.id}
                    patientId={patientId}
                    item={item}
                    permissions={permissions}
                    onCarePlanChange={onCarePlanChange}
                  />
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4}>
                    <NoDataFound />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {showCreate && (
        <Icd10CodeModal
          patientId={patientId}
          applyCodeInitialValues={getInitialValues({} as ICarePlanIcd10Code)}
          onClose={() => setShowCreate(false)}
          onCarePlanChange={onCarePlanChange}
        />
      )}
    </div>
  );
};

export default Icd10Codes;
